import {darken} from 'polished';
import styled from 'styled-components';

import {border, colors} from '../../../../../theme';

import {Icon} from '../../../Icon';

export const SortingIndicatorIcon = styled(Icon)<{isSortedDesc?: boolean; fillColor?: string}>`
    vertical-align: baseline;
    transform: rotate(${(p) => (p.isSortedDesc ? '0' : '180deg')});
    padding: 3px;
    border-radius: ${border.radius};
    cursor: pointer;
    color: ${(p) => p.fillColor};
    transition: color 0.15s ease-in-out;

    &:hover {
        color: ${darken(0.05, colors.brandPrimary)};
    }
`;
